module.exports = __webpack_public_path__ + "img/xbox.9198c9a8.svg";